(function () {
  var STORAGE_KEY = "scs_hero_variant";

  var settingsEl = document.getElementById("scs-hero-variation-settings");
  var configEl = document.getElementById("scs-hero-variations-config");
  var banner = document.getElementById("banner-item-1");

  if (!settingsEl || !configEl || !banner) {
    document.documentElement.classList.remove("scs-hero-var-pending");
    return;
  }

  var settings;
  var variations;

  try {
    settings = JSON.parse(settingsEl.textContent);
    variations = JSON.parse(configEl.textContent);
  } catch (error) {
    document.documentElement.classList.remove("scs-hero-var-pending");
    return;
  }

  if (!Array.isArray(variations)) {
    document.documentElement.classList.remove("scs-hero-var-pending");
    return;
  }

  function normalizeSlug(raw) {
    if (!raw) return "";
    return raw
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function findVariation(slug) {
    for (var i = 0; i < variations.length; i += 1) {
      if (variations[i] && variations[i].slug === slug) {
        return variations[i];
      }
    }
    return null;
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var data = JSON.parse(raw);
      if (!data || !data.slug || !data.expires || Date.now() > data.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return findVariation(data.slug) ? data : null;
    } catch (error) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function writeStored(slug, hours) {
    var existing = readStored();
    if (existing && existing.slug === slug) {
      return;
    }

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        slug: slug,
        expires: Date.now() + hours * 60 * 60 * 1000,
      })
    );
  }

  function maybePersist(slug, match) {
    if (!match || !match.persistence) return;
    writeStored(slug, Number(match.hours) || 24);
  }

  function applyVariation(match, slug) {
    banner.setAttribute("data-hero-variant", slug);

    var heading = banner.querySelector(".heading");
    if (heading && match.title) {
      heading.textContent = match.title;
    }

    var picture = banner.querySelector(".banner-item-1__media");
    if (picture) {
      if (match.desktop_image) {
        var img = picture.querySelector(".banner-item-1__image");
        if (img) img.src = match.desktop_image;
      }

      if (match.mobile_image) {
        var source = picture.querySelector("source");
        if (source) source.srcset = match.mobile_image;
      }
    }
  }

  var serverApplied = Boolean(settings.serverApplied);
  var urlSlug = normalizeSlug(new URLSearchParams(window.location.search).get("utm_term"));
  var urlMatch = urlSlug ? findVariation(urlSlug) : null;

  if (urlMatch) {
    maybePersist(urlSlug, urlMatch);
  }

  if (serverApplied) {
    var serverSlug = banner.getAttribute("data-hero-variant");
    if (serverSlug) {
      maybePersist(serverSlug, findVariation(serverSlug));
    }
    document.documentElement.classList.remove("scs-hero-var-pending");
    return;
  }

  var activeSlug = urlMatch ? urlSlug : null;

  if (!activeSlug) {
    var stored = readStored();
    if (stored) {
      activeSlug = stored.slug;
    }
  }

  var activeMatch = activeSlug ? findVariation(activeSlug) : null;

  if (activeMatch) {
    applyVariation(activeMatch, activeSlug);
  }

  document.documentElement.classList.remove("scs-hero-var-pending");
})();
